import { h } from 'preact'

import { IconComponentProps } from './index'

const SendIcon = ({ width = 32, height = 32, customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' className={customClass}>
    <path d='M29.3334 2.66675L14.6667 17.3334' stroke='#0069FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    <path d='M29.3334 2.66675L20 29.3334L14.6667 17.3334L2.66669 12.0001L29.3334 2.66675Z' stroke='#0069FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)

export default SendIcon
